<template>
    <div>
        <v-layout row :class="{'mt-4':!image}">
            <v-layout column>
                <label class="mb-2">{{ label }}</label>
                <v-img v-if="image&&!dialog" :src="image" max-height="40" contain></v-img>
            </v-layout>
            <v-spacer></v-spacer>
            <div style="width:30px;">
                <v-layout column>
                    <v-icon class="mb-2"
                            small
                            @click="dialog=true"
                    >
                        fa-edit
                    </v-icon>
                    <v-icon v-if="image"
                            small
                            @click="image=null"
                    >
                        fa-trash
                    </v-icon>
                </v-layout>
            </div>
        </v-layout>
        <v-dialog v-model="dialog" max-width="800" persistent>
            <v-card>
                <v-card-title class="primary white--text title">
                    {{label}}
                </v-card-title>
                <v-card-text>
                    <v-text-field :label="'Image URL or Base64'|translate" v-model="image"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog=false">{{ 'OK'|translate }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
    export default {
        name: 'ImagePicker',
        props: {
            value:{type:String},
            label:{type:String, default:"Image"}
        },
        data () {
            return {
                dialog:false,
                image:null,
            };
        },
        methods:{

        },
        mounted(){
            if(this.image!==this.value){
                this.image = this.value
            }
        },
        watch: {
            value () {

            },
            image (newImage) {
                this.$emit('input', newImage)
            },
        }

    }
</script>